import { Injectable } from '@angular/core';
import { LanguageService } from './language.service';
import { Router, NavigationStart } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class LanguageRedirectService {

constructor(private router: Router, private languageService: LanguageService) { }
  init(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (typeof window !== 'undefined' && window.localStorage) {
        let path = window.location.pathname;
        const lang = this.languageService.getStoredLanguage().code;


        if (path !== '/' && path.endsWith('/')) {
          path = path.slice(0, -1);
          window.history.replaceState({}, '', path);
        }

        if (path === '/' && lang !== 'en') {
          window.location.replace(`/${lang}`);
        }
      }
      resolve();
    });
  }
 
}
